<div class="case-feature-preview">
  <div class="case-feature-preview__body">
    <div *ngIf="isLoading(); else clipsContent" class="case-feature-preview__loader">
      <ui-preloader [color]="preloaderColor"></ui-preloader>
    </div>

    <ng-template #clipsContent>
      <div *ngIf="archives().length; else noClips" class="case-feature-list">
        <div
          *ngFor="let archive of archives()"
          class="case-feature-card case-feature-card--clickable"
          (click)="openArchive(archive)"
        >
          <div class="case-feature-card__thumb">
            <img
              [appAuthSrc]="archive.mainThumbnailUrl ?? ''"
              [appAuthSrcFallback]="fallbackThumbnail"
              [alt]="archive.name"
            />
          </div>

          <div class="case-feature-card__content">
            <div class="case-feature-card__header">
              <div class="case-feature-card__title" [title]="archive.name">
                {{ archive.name }}
              </div>

              <div
                *ngIf="canDownloadArchive(archive) || canEdit()"
                class="case-feature-card__actions"
                (click)="$event.stopPropagation()"
              >
                <ui-preloader
                  *ngIf="isBusy(archive); else clipMenuTrigger"
                  [color]="preloaderColor"
                  [diameter]="18"
                ></ui-preloader>
                <ng-template #clipMenuTrigger>
                  <span
                    class="case-feature-card__menu-icon ui-icon-more-menu"
                    [matMenuTriggerFor]="clipMenu"
                  ></span>
                </ng-template>
              </div>

              <mat-menu #clipMenu="matMenu" xPosition="before">
                <button *ngIf="canDownloadArchive(archive)" mat-menu-item type="button" (click)="downloadArchive(archive)">
                  {{ 'COMMON.DOWNLOAD' | translate }}
                </button>
                <button
                  *ngIf="canEdit()"
                  mat-menu-item
                  type="button"
                  [disabled]="isVideoSignatureDisabled(archive)"
                  (click)="videoSignature(archive)"
                >
                  {{ 'ARCHIVE.TABLE.VIDEO_SIGNATURE' | translate }}
                </button>
                <button *ngIf="canEdit()" mat-menu-item type="button" (click)="deleteClip(archive)">
                  {{ 'COMMON.DELETE' | translate }}
                </button>
              </mat-menu>
            </div>

            <div class="case-feature-card__meta">
              <span class="ui-icon-time"></span>
              <span>{{ archive.start | date: 'MMM d, h:mm:ss a' }} - {{ archive.end | date: 'h:mm:ss a' }}</span>
            </div>

            <div *ngIf="archive.cameraMapConfig?.address || archive.edgeMapConfig?.address || archive.locationAddress" class="case-feature-card__meta">
              <span class="ui-icon-map-view"></span>
              <span>{{ archive.cameraMapConfig?.address || archive.edgeMapConfig?.address || archive.locationAddress }}</span>
            </div>

            <div *ngIf="archive.totalAnnotations" class="case-feature-card__meta">
              <span class="ui-icon-film"></span>
              <span>{{ archive.totalAnnotations }} {{ 'CASE_ANNOTATE_DIALOG.ANNOTATIONS' | translate }}</span>
            </div>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #noClips>
      <div class="case-feature-preview__empty">
        <span class="case-feature-preview__empty-icon ui-icon-camera-off"></span>
        <div>{{ 'CASES.CLIPS.NO_DATA.TITLE' | translate }}</div>
      </div>
    </ng-template>
  </div>
</div>
